import { render, staticRenderFns } from "./Symptoms.vue?vue&type=template&id=f0439234&"
import script from "./Symptoms.vue?vue&type=script&lang=ts&"
export * from "./Symptoms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports